export default __webpack_public_path__ + "static/media/Sachin1.cd67da90.jpg";